import { rem } from 'polished';
import { breakpoints, css } from '../../../styles/theme';

export const StylesOV = css`
  background-color: ${({ theme }) => theme.colors.white};
  
  .my-account-page {
    background: ${(p) => p.theme.colors.pureWhite};

    .my-account-content {
      display: flex;
      justify-content: center;

      &-title {
        display: none;
        margin-left: ${rem('12px')};
        font-weight: normal;
        @media (min-width: ${breakpoints.xs}px) {
          display: initial;
          text-transform: uppercase;
          line-height: ${rem('36px')};
          margin-bottom: ${rem('30px')};
          font-size: ${rem('24px')};
        }

      }

      .my-account-controller {
        display: flex;
        padding-bottom: ${rem(20)};
      }

      .my-account-home .imgbtn {
        width: ${rem('328px')};
        margin: ${rem('16px')};
        @media (min-width: ${breakpoints.xs}px) {
          height: ${rem(252)};
          width: ${rem('328px')};
          margin: 0 ${rem('16px')};
        }
        
        .img-btn-container {
            height: ${rem(233)};
        }
      }
  
	  .my-account-breadcrumbs {
			div {
				a, span {
		  		color: ${({ theme }) => theme.colors.grey22};
		  		font-size: ${({ theme }) => theme.fontSizes.textSupBase};
					font-weight: normal;
					
					:not(:first-child) {
						:before {
							content: '/';
			  			color: ${({ theme }) => theme.colors.grey22};
						}
					}
				}
	  	}
	  }

    }
`;
